import { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Floater, Auth } from 'components'

// 데이터연동 통합인증
import Home from './home'
// import Data from './Data'
import MethodSelect from './MethodSelect'
import ConnectionDetail from './ConnectionDetail'
import DataLinkResult from './dataLinkResult'
import CertiNone from './CertiNone'
import CertiManage from './CertiManage'
import CertiBring from './CertiBring'
import DataLoading from './DataLoading'
import DataDetail from './DataDetail'
import DataDetailNone from './DataDetailNone'
import DataFail from './DataFail'
import DetailLinkResult from './DetailLinkResult'
import DataDetailLoading from './DataDetailLoading'
import DataGifLoading from './DataGifLoading'
import TransmitRequest from './terms/TransmitRequest'

import CertSelect from './certSelect'

// 데이터연동 개별인증
import DataEachTerms1 from './terms/DataEachTerms1'
import DataEachTerms2 from './terms/DataEachTerms2'

// 데이터연동 오류 및 검색
import DataServiceCheck from './DataServiceCheck'
import DataConnectionError from './DataConnectionError'
import DataSearch from './DataSearch'
import DataSearchResult from './DataSearchResult'
import DataSearchError from './DataSearchError'

// 데이터 관리
import ExtendLinkResult from './extendLinkResult'

// data
const Index = () => {

	return (
		<>
			<Floater>
				<li><Link to="">마이데이터 연결하기 (기관선택)</Link></li>
				<li><Link to="methodSelect">마이데이터 연결하기 (인증수단 선택)</Link></li>
				<li><Link to="connectionDetail">마이데이터 연결하기 약관동의(상세)</Link></li>
				<li><Link to="certiNone">마이데이터 연결하기 인증서 없을 때</Link></li>
				<li><Link to="certiManage">인증서 목록</Link></li>
				<li><Link to="certiBring">인증서 가져오기</Link></li>
				<li><Link to="dataLoading">마이데이터 연결하기 로딩</Link></li>
				<li><Link to="dataDetail">마이데이터 연결하기 상세연결</Link></li>
				<li><Link to="dataDetailNone">마이데이터 연결하기 상세연결 (데이터 없음)</Link></li>
				<li><Link to="dataFail">마이데이터 연결하기 상세연결 실패</Link></li>
				<li><Link to="detailLinkResult">detailLinkResult 마이데이터 연결하기 상세연결 결과</Link></li>
				<li><Link to="dataDetailTerms1">dataDetailTerms1 마이데이터 연결하기 상세연결 전송요구 및 동의 1</Link></li>
				<li><Link to="dataDetailTerms2">dataDetailTerms2 마이데이터 연결하기 상세연결 전송요구 및 동의 2</Link></li>
				<li><Link to="dataDetailLoading">마이데이터 연결하기 상세연결 로딩</Link></li>
				<li><Link to="dataGifLoading">마이데이터 로딩</Link></li>
				<li><Link to="dataEachTerms1">마이데이터 연결하기 개별인증 전송요구 및 동의 1</Link></li>
				<li><Link to="dataEachTerms2">마이데이터 연결하기 개별인증 전송요구 및 동의 2</Link></li>
				<li><Link to="dataServiceCheck">마이데이터 연결하기 서비스 점검 중</Link></li>
				<li><Link to="dataConnectionError">마이데이터 연결하기 연동오류</Link></li>
				<li><Link to="dataSearch">마이데이터 연결하기 검색</Link></li>
				<li><Link to="dataSearchResult">마이데이터 연결하기 검색결과</Link></li>
				<li><Link to="dataSearchError">마이데이터 연결하기 검색에러</Link></li>
			</Floater>
			<Routes>
				<Route path="/certSelect" element={<CertSelect />} /> { /* 인증서 목록 */}
				<Route path="/methodSelect" element={<MethodSelect />} /> { /* 마이데이터 연결하기 (인증수단 선택) */}
				<Route path="/connectionDetail" element={<ConnectionDetail />} /> { /* 마이데이터 연결하기 약관동의(상세) */}
				<Route path="/transmitRequest" element={<TransmitRequest />} /> { /* 마이데이터 연결하기 전송요구및정보제공동의 1 - 개발 */}
				<Route path="/dataLinkResult" element={<DataLinkResult />} /> { /* 목록 연동 결과 */}

				
				<Route path="/extendLinkResult" element={<ExtendLinkResult />} /> { /* 기간 연장 결과 */}

				
				<Route path="/certiNone" element={<CertiNone />} /> { /* 마이데이터 연결하기 인증서 없을 때 */}
				<Route path="/certiBring" element={<CertiBring />} /> { /* 인증서 가져오기 */}
				<Route path="/dataLoading" element={<DataLoading />} /> { /* 마이데이터 연결하기 로딩 */}
				<Route path="/dataGifLoading" element={<DataGifLoading />} /> { /* 마이데이터 연결하기 로딩 */}

				<Route path="/dataDetail" element={<DataDetail />} /> { /* 마이데이터 연결하기 상세연결 */}
				<Route path="/dataDetailNone" element={<DataDetailNone />} /> { /* 마이데이터 연결하기 상세연결 (데이터 없음) */}
				<Route path="/dataFail" element={<DataFail />} /> { /* 마이데이터 연결하기 상세연결 실패 */}
				<Route path="/detailLinkResult" element={<DetailLinkResult />} /> { /* 마이데이터 연결하기 상세연결 결과 !!! */}
				
				<Route path="/dataDetailLoading" element={<DataDetailLoading />} /> { /* 마이데이터 연결하기 상세연결 로딩 */}

				<Route path="/dataEachTerms1" element={<DataEachTerms1 />} /> { /* 마이데이터 연결하기 개별인증 전송요구 및 동의 1 */}
				<Route path="/dataEachTerms2" element={<DataEachTerms2 />} /> { /* 마이데이터 연결하기 개별인증 전송요구 및 동의 2 */}

				<Route path="/dataServiceCheck" element={<DataServiceCheck />} /> { /* 마이데이터 연결하기 서비스 점검 중 */}
				<Route path="/dataConnectionError" element={<DataConnectionError />} /> { /* 마이데이터 연결하기 연동오류 */}
				<Route path="/dataSearch" element={<DataSearch />} /> { /* 마이데이터 연결하기 검색 */}
				<Route path="/dataSearchResult" element={<DataSearchResult />} /> { /* 마이데이터 연결하기 검색결과 */}
				<Route path="/dataSearchError" element={<DataSearchError />} /> { /* 마이데이터 연결하기 검색에러 */}
				<Route path="/certiManage" element={<CertiManage />} /> { /* 인증서 목록 */}

				<Route path="/" element={<Auth><Home /></Auth>} /> { /* 마이데이터 연결하기 (기관선택) */}
			</Routes>
		</>
	)
}

export default Index